import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * プロフィール取得API
 * @param  {} params={}
 */
export const fetch = (params = {}) => {
  const defaults = {
    _path: 'PR/001',
    token: store.state.auth.token
  }

  // paramsにtokenが設定されている場合は、その値がtokenとして優先される
  // (無料トライアルの受信メールのURLからアクセスした場合のトークン認証時)
  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * プロフィール更新API
 * @param  {} params={}
 */
export const update = (params = {}) => {
  const defaults = {
    _path: 'PR/002',
    token: store.state.auth.token
  }

  // アラート書籍削除用に空配列で送信せずに、[0]を送信
  if (params.alert_books && params.alert_books.length === 0) {
    params.alert_books = [0]
  }


  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * プロフィール更新API（ファイル送信）
 * @param  {} params={}
 */
export const updateProfileImage = (file, type, id) => {
  const r = new FormData()
  r.append('token', store.state.auth.token)
  r.append('file', file)
  r.append('profile_image_upload', type)
  r.append('user_id', id)
  r.append('_path', 'PR/002')

  const options = {
    'content-type': 'multipart/form-data',
    responseType: type === '1'
      ? 'arraybuffer'
      : 'json'
  }
  

  return axios.post(API_RELAY_PATH, r, options)
}

/**
 * パスワード変更（メール送信）API
 * @param  {} params={}
 */
export const changePassword = (params = {}) => {
  const defaults = {
    _path: 'PR/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
